import React from 'react';
import startCase from 'lodash/startCase';
import capitalize from 'lodash/capitalize';

import './index.scss';
import BarChart from './NivoBarChart';
import LineChart from './NivoLineChart';
import { aggProps, colorProps } from '../App';

const DataPanel = ({ data, inView, aggProp, setAggProp, colorProp, setColorProp, color, uniquePropsMap, filterProp, setFilterProp, geocodeRef }) => {
  const inViewSet = new Set(inView);
  const features = data['features'].filter(f => inViewSet.has(f.properties.id));
  return (
    <div>
      <div className="c__mapsearch" ref={geocodeRef}>
      </div>
      <div className="block__header--barchart">
        <h3 className="bp3-heading">
          DA's in NSW
        </h3>
        <label className="bp3-label bp3-inline">
          <strong>Show</strong>
          <div className="bp3-select">
            <select onChange={evt => setAggProp(evt.target.value)} defaultValue={aggProps[0]}>
              {aggProps.map((p, i) => (<option key={i} value={p}> {capitalize(startCase(p))}</option>))}
            </select>
          </div>
        </label>
      </div>

      <div className="block--barchart">
        {colorProps.filter(p => p !== 'SUBMITTED_MONTH').map(group_prop => {
          return <BarChart
            key={group_prop}
            features={features}
            aggProp={aggProp}
            group_prop={group_prop}
            colorProp={colorProp}
            color={color}
            setColorProp={setColorProp}
            filterProp={filterProp}
            setFilterProp={setFilterProp}
            uniquePropsMap={uniquePropsMap}
          />
        })}
        <LineChart
          features={features}
          aggProp={aggProp}
          colorProp={colorProp}
          color={color}
          filterProp={filterProp}
        />
      </div>

    </div>
  )

}


export default DataPanel;
